<template>
  <div class="animated fadeIn">
    <b-alert :variant="dismissibleType"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>
    <div>
      <b-card>
        <div slot="header">
          <strong class="mdrive-header-text">Manage Tracked Lenders</strong>
          <div class="pull-right">
            <button id="btnSaveActiveLend" class="btn btn-primary" @click="saveLenders"><i title="Save" class="fa fa-save fa-lg text-white"></i> <strong class="text-white">Save</strong></button>
          </div>
        </div>

        <b-row>
          <b-col lg="5">
            <b-card class="border m-0">
              <div slot="header">Available Lenders</div>
              <!-- User Interface controls -->
              <b-row style="height: 50px;">
                <b-col class="my-0">
                  <b-form-group class="my-1">
                    <b-form-input id="inpSearchAvailLend" placeholder="Type here to search our available lenders" v-model="tbxSearch" />
                  </b-form-group>
                </b-col>
              </b-row>
              <!-- Main table element -->
              <b-row style="height: 600px; overflow: auto">
                <b-col lg="12 " class="p-0 m-0">
                  <table id="tableAvailLenders" aria-busy="false" aria-colcount="3" class="table b-table table-striped table-bordered table-sm">
                    <thead class="thead-light">
                      <tr>
                        <th aria-colindex="1">Lender Name</th>
                        <th aria-colindex="2">Lease<br /><a href="#" @click="selectAllCaptives(1)">Select All Captive</a></th>
                        <th aria-colindex="3">Finance<br /><a href="#" @click="selectAllCaptives(0)">Select All Captive</a></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="!lenders.length" class="b-table-empty-row">
                        <td colspan="3"><div role="alert" aria-live="polite"><div class="text-center my-2">No lenders found.</div></div></td>
                      </tr>
                      <tr v-for="(l, i) in filteredItems">
                        <td>
                          {{ l.name }}
                        </td>
                        <td>
                          <c-switch :id="l.lender_id" v-if="l.availableForLease" v-model="l.activeForLease" type="text" variant="primary" on="On" off="Off" :pill="true" />
                        </td>
                        <td>
                          <c-switch :id="l.lender_id" v-if="l.availableForRetail" v-model="l.activeForRetail" type="text" variant="primary" on="On" off="Off" :pill="true" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-col>
              </b-row>

            </b-card>

          </b-col>
          <b-col lg="7" >

            <b-card class="border m-0">
              <div slot="header">Active Lenders</div>
              <b-row style="height: 650px; overflow: auto">
                <b-col lg="12" class="p-0 m-0">
                  <table id="tableActiveLenders" aria-busy="false" aria-colcount="3" class="table b-table table-striped table-bordered table-sm">
                    <thead class="thead-light">
                      <tr>
                        <th aria-colindex="1">Lender Name</th>
                        <th aria-colindex="2">Lease<br /><a href="#" @click="deselectAllCaptives(1)">Remove All Captive</a></th>
                        <th v-if="bIsmProveActive" aria-colindex="3" colspan="3">DMS Code</th>
                        <th aria-colindex="4">Finance<br /><a href="#" @click="deselectAllCaptives(0)">Remove All Captive</a></th>
                        <th v-if="bIsmProveActive" aria-colindex="5" colspan="3">DMS Code</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="!activeItems" class="b-table-empty-row">
                        <td colspan="7"><div role="alert" aria-live="polite"><div class="text-center my-2">No lenders added yet.</div></div></td>
                      </tr>
                      <tr v-for="(l, i) in lenders" v-if="l.activeForLease || l.activeForRetail">
                        <td>
                          {{ l.name }}
                        </td>
                        <td>
                          <c-switch :id="l.lender_id" v-if="l.availableForLease" v-model="l.activeForLease" type="text" variant="primary" on="On" off="Off" :pill="true" />
                        </td>
                        <td v-if="bIsmProveActive">
                          <b-form-input v-if="l.availableForLease" type="text" v-model="l.se_code_lease"></b-form-input>
                        </td>
                        <td v-if="bIsmProveActive">
                          <b-btn v-if="se_lenders_lease && l.availableForLease" size="sm" class="btn btn-success text-white ml-2" v-b-modal="'modal-selender'" lender="'l'" @click="selectLender(l,1)">...</b-btn>
                        </td>
                        <td v-if="bIsmProveActive">
                          <b-btn v-if="l.se_code_lease" size="sm" class="btn btn-info text-white ml-2" lender="'l'" @click="l.se_code_lease=''">x</b-btn>
                        </td>
                        <td>
                          <c-switch :id="l.lender_id" v-if="l.availableForRetail" v-model="l.activeForRetail" type="text" variant="primary" on="On" off="Off" :pill="true" />
                        </td>
                        <td v-if="bIsmProveActive">
                          <b-form-input v-if="l.availableForRetail" type="text" v-model="l.se_code_retail"></b-form-input>
                        </td>
                        <td v-if="bIsmProveActive">
                          <b-btn v-if="se_lenders_retail && l.availableForRetail" size="sm" class="btn btn-success text-white ml-2" v-b-modal="'modal-selender'" lender="'l'" @click="selectLender(l,0)">...</b-btn>
                        </td>
                        <td v-if="bIsmProveActive">
                          <b-btn v-if="l.se_code_retail" size="sm" class="btn btn-info text-white ml-2" lender="'l'" @click="l.se_code_retail=''">x</b-btn>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-col>
              </b-row>

            </b-card>

            <!-- Main table element -->

          </b-col>
        </b-row>
      </b-card>
    </div>
    <b-modal id="modal-selender" ref="modal-sel" scrollable title="DMS codes" size="lg" ok-only ok-titile="Close">
      <!--<b-row>
        <div class="my-0">
          <b-form-input placeholder="Type to Search" v-model="tbxSESearch" style="margin-bottom:10px" />
        </div>
      </b-row>-->
      <table aria-busy="false" aria-colcount="3" class="table b-table table-striped table-bordered table-sm ">
        <thead class="thead-light">
          <tr>
            <th aria-colindex="1">Lender Name</th>
            <th aria-colindex="2">Code</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!se_lenders.length" class="b-table-empty-row">
            <td colspan="7"><div role="alert" aria-live="polite"><div class="text-center my-2">No lenders found.</div></div></td>
          </tr>
          <tr v-for="(l, i) in se_lenders" v-bind:class="{'selected': (l.lender_code == se_lender_code_sel)}" :ref="i">
            <td>
              {{ l.lender_name }}
            </td>
            <td>
              {{ l.lender_code }}
            </td>
            <td>
              <b-btn class="btn btn-success text-white ml-2" lender="'l'" @click="selectAndClose(l)">map</b-btn>
            </td>
          </tr>
        </tbody>
      </table>

    </b-modal>

    <loading :show="boolLoading"
             :label="txtLoading">
    </loading>
  </div>
</template>

<script>
import axios from 'axios'
import loading from 'vue-full-loading'
import cSwitch from '../components/Switch'

export default {
  components: {
    loading,
    cSwitch
  },
  created () {
    axios.get('/api/lenders/loaddata')
      .then(response => {
        this.dealershipId = response.data.dealershipId
        this.lenders.splice(0)
        for (let i = 0; i < response.data.data.length; i++) {
          this.lenders.push(response.data.data[i])
        }

        this.bIsmProveActive = response.data.bIsmProveActive
        this.boolLoading = false
        if (response.data.bIsmProveActive) {
          var obj = {}
          obj.dealershipId = this.dealershipId
          axios.post('/api/lenders/getstoneedgelenders', obj)
            .then(response => {
              var se_lenders = response.data.data
              this.se_lenders_lease = se_lenders.filter(function (e) {
                return e.type === 1
              })
              this.se_lenders_retail = se_lenders.filter(function (e) {
                return e.type === 0
              })
            })
            .catch(error => {
              this.errMsg = 'There was an error getting data : ' + error
              this.showDismissibleAlert = true
            })
        }
      })
      .catch(error => {
        if (error.response.status == 403) { this.$router.push('/login') }

        this.boolLoading = false
        this.errMsg = 'There was an error getting data : ' + error
        this.showDismissibleAlert = true
      })
  },
  data () {
    return {
      errMsg: '',
      dismissibleType: 'danger',
      showDismissibleAlert: false,
      boolLoading: false,
      txtLoading: 'Loading...',
      tbxSearch: '',
      dealershipId: 0,
      lenders: [],
      se_lenders_lease: [],
      se_lenders_retail: [],
      se_lenders: [],
      se_lender_type_sel: 2,
      se_lender_code_sel: '',
      se_lender_sel: null,
      selMode: 'single',
      tbxFilter: undefined,
      bIsmProveActive: false
    }
  },
  methods: {
    saveLenders () {
      var self = this
      if (!this.lenders) {
        this.errMsg = 'Unknown error.'
        this.showDismissibleAlert = true
        return
      }
      // if (this.activeItems > 15) {
      // this.errMsg = 'Sorry, but you may have no more than 15 active lenders.'
      // this.showDismissibleAlert = true
      // return
      // }
      this.boolLoading = true
      var obj = {}
      obj.data = this.lenders
      obj.dealershipId = self.dealershipId
      axios.post('/api/lenders/save', obj)
        .then(response => {
          this.errMsg = 'Lenders Saved'
          this.dismissibleType = 'success'
          this.showDismissibleAlert = true
          this.boolLoading = false
          if (this.activeItems > 0) {
            this.$emit('clicked', 'true')
          } else {
            this.$emit('clicked', 'false')
          }
          return true
        })
        .catch(error => {
          if (error.response.status === 403 && error.response.statusText.indexOf('403.1') === -1) { this.$router.push('/login') }
          console.log(error)
          this.boolLoading = false
          this.errMsg = 'There was an error saving data : ' + error
          this.showDismissibleAlert = true
          if (error.response.status == 403 && error.response.statusText.indexOf('403.1') !== -1) { this.errMsg = error.response.statusText.replace('403.1', '') }
          return false
        })
    },
    ClearSearch () {
      this.tbxFilter = ''
    },
    EscClearSearch (event) {
      let self = this
      if (event.key === 'Escape') {
        self.ClearSearch()
      }
    },
    rowClass (item, type) {
      if (!item) return
      if (item['selected'] == true) return 'table-success'
    },
    selectLender (item, fin_type) {
      this.se_lender_type_sel = fin_type
      if (fin_type === 1) {
        this.se_lender_code_sel = item['se_code_lease']
        this.se_lenders = this.se_lenders_lease
      } else {
        this.se_lender_code_sel = item['se_code_retail']
        this.se_lenders = this.se_lenders_retail
      }
      this.se_lender_sel = item
    },
    selectAllCaptives(fin_type) {
      if (fin_type === 1)
        this.lenders.forEach(this.selectCaptiveLease)
      else
        this.lenders.forEach(this.selectCaptiveRetail)
    },
    deselectAllCaptives(fin_type) {
      if (fin_type === 1)
        this.lenders.forEach(this.deselectCaptiveLease)
      else
        this.lenders.forEach(this.deselectCaptiveRetail)
    },
    selectCaptiveLease(lender, index) {
      console.log(this)
      if (lender.isCaptive) {
        lender.activeForLease = true
      }
    },
    selectCaptiveRetail(lender, index) {
      if (lender.isCaptive) {
        lender.activeForRetail = true
      }
    },
    deselectCaptiveLease(lender, index) {
      console.log(this)
      if (lender.isCaptive) {
        lender.activeForLease = false
      }
    },
    deselectCaptiveRetail(lender, index) {
      if (lender.isCaptive) {
        lender.activeForRetail = false
      }
    },

    selectAndClose (item) {
      var self = this
      var selIdx = self.lenders.findIndex(l => l.name === self.se_lender_sel.name)
      if (selIdx) {
        if (self.se_lender_type_sel === 1) {
          self.lenders[selIdx].se_code_lease = item['lender_code']
        } else {
          self.lenders[selIdx].se_code_retail = item['lender_code']
        }

        // self.$forceUpdate()
      }
      self.$refs['modal-sel'].hide()
    }

  },
  directives: {
    focus: {
      bind: function (el, binding) {
        if (binding.value === this.selSELenderId) { el.focus() }
      }
    }
  },
  computed: {
    activeItems () {
      return this.lenders.filter(f => { return f.activeForLease || f.activeForRetail }).length
    },
    filteredItems () {
      return this.lenders.filter(item => {
        return item.name.toLowerCase().indexOf(this.tbxSearch.toLowerCase()) > -1
      })
    }
  },
  mounted () {
    // boolLoading must be set to false on data() binding so that mount hooks the change
    this.boolLoading = true
  }

}
// # sourceURL=Lenders.vue
</script>
<style scoped>
  .selectable tr {
    cursor: pointer;
  }

  .selected {
    background-color: powderblue !important;
  }

  .dropdown {
    position: relative;
    display: inline-block;
  }

  .col {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  /* Card Header */

  .card-header {
    padding: 1.25rem calc(1.25rem + 15px) !important;
  }

  .mdrive-header-text {
    line-height: 35px;
  }

  #btnSaveActiveLend {
    /* border-radius: .25rem !important; */
    margin-top: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/Lenders.vue